var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1621 7.10156L16.3246 2.87656C15.4996 2.42656 14.4996 2.42656 13.6746 2.87656L5.83711 7.10156C5.26211 7.41406 4.91211 8.01406 4.91211 8.70156C4.91211 9.37656 5.26211 9.98906 5.83711 10.3016L13.6746 14.5266C14.0871 14.7516 14.5496 14.8641 14.9996 14.8641C15.4496 14.8641 15.9121 14.7516 16.3246 14.5266L24.1621 10.3016C24.7371 9.98906 25.0871 9.38906 25.0871 8.70156C25.0871 8.01406 24.7371 7.41406 24.1621 7.10156Z",
    fill: "#32AE4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3875 15.9875L5.0875 12.3375C4.525 12.0625 3.875 12.0875 3.35 12.4125C2.8125 12.75 2.5 13.3125 2.5 13.9375V20.825C2.5 22.0125 3.1625 23.0875 4.225 23.625L11.5125 27.275C11.7625 27.4 12.0375 27.4625 12.3125 27.4625C12.6375 27.4625 12.9625 27.375 13.25 27.2C13.7875 26.875 14.1 26.3 14.1 25.675V18.7875C14.1125 17.5875 13.45 16.5125 12.3875 15.9875Z",
    fill: "#32AE4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6504 12.4137C26.1129 12.0887 25.4629 12.0512 24.9129 12.3387L17.6254 15.9887C16.5629 16.5262 15.9004 17.5887 15.9004 18.7887V25.6762C15.9004 26.3012 16.2129 26.8762 16.7504 27.2012C17.0379 27.3762 17.3629 27.4637 17.6879 27.4637C17.9629 27.4637 18.2379 27.4012 18.4879 27.2762L25.7754 23.6262C26.8379 23.0887 27.5004 22.0262 27.5004 20.8262V13.9387C27.5004 13.3137 27.1879 12.7512 26.6504 12.4137Z",
    fill: "#32AE4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.049ef4b40d29a71c1c6526c78cc88818.svg";
export { ForwardRef as ReactComponent };